import useAuthenticatedMutation from '../useAuthenticatedMutation';
import PropTypes from 'prop-types';
import axios from 'axios';
import { API_BASE_URL, FUNCTION_KEY, PROJECT_SCOPE } from '../../../config';

// Function to perform HTTP requests
const manageOrganisationAPIKeys = async ({data, method}, token) => {
    let url = `${API_BASE_URL}disqoadmin/organisation_keys`;

    if (method === 'DELETE' && data.api_key_id) {
        url += `?api_key_id=${data.api_key_id}`; // Add to URL for DELETE
    }

    try {
        const response = await axios({
            method: method,
            url: url,
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-functions-key': FUNCTION_KEY,
            },
            data: method !== 'DELETE' ? data : {}, // Only send data for non-DELETE requests
        });

        return response.data;
    } catch (error) {
        logError(`Failed to ${method.toLowerCase()} organisation keys:`, error, { "method": method, "data": data });
        throw (error?.response?.data) ? error.response.data : error;
    }
};

// Hook to manage organisations
export default function useOrganisationAPIKeyManager(onSuccess, onError) {
    
    const projectScope = [PROJECT_SCOPE];
    const { mutate, isLoading, isError, error, data, reset: resetMutation } = useAuthenticatedMutation(manageOrganisationAPIKeys, projectScope, {
        onSuccess,
        onError
    });

    // Function to call the mutate function with additional parameters for different HTTP methods
    const performAction = (data, method = 'POST') => {
        // Structure the data here to include the method, the token is added by the mutation function
        mutate({
            data: data,
            method: method
        });
    };

    return {
        performAction,
        isLoading,
        isError,
        error,
        data,
        reset: resetMutation
    };
}

useOrganisationAPIKeyManager.propTypes = {
    onSuccess: PropTypes.func,
    onError: PropTypes.func
};